import { MasterDataService } from 'src/app/services/master-data.service';
import { Component, Input, OnInit, EventEmitter, Output, inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { routes } from 'src/app/app.routes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Webinar } from 'src/app/models/oem-models';
import { OemService } from 'src/app/services/oem/oem.service';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import Swal from 'sweetalert2';
import { map, Observable, startWith, Subscription } from 'rxjs';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-add-webinar',
  templateUrl: './add-webinar.component.html',
  styleUrls: ['./add-webinar.component.scss']
})

export class AddWebinarComponent implements OnInit {
  @Input() addWebinar?: boolean;
  @Input() updateWebinar?: boolean = false;
  @Input() updateWebinarID?: any;
  @Output() backEvent = new EventEmitter<any>();
  @Output() closeToBack = new EventEmitter<any>();
  @Output() data = new EventEmitter<string>();
  @Input() returnPath?: string;

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER] as const;

  addWebinarForm!: FormGroup;
  announcer = inject(LiveAnnouncer);

  valid: boolean = true;
  specialities!: any[];
  filteredSpeciality: Observable<any[]> = new Observable<any[]>();
  filteredSpecialities: any[] = [];
  filteredTimezones: string[] = [];
  searchTimezone: string = '';
  speakersName: string[] = [];
  oemId: any;
  timezones: any[] = [];
  iswebinarActive: boolean = false;
  isImage: boolean = true;
  fileName = '';
  fileNameHost = '';
  currentFile?: File;
  currentFileHost?: File;
  selectedFileName: string | null = null;
  selectedFileNameHost: string | null = null;
  imageUrl: string = '';
  imageUrlHost: any = undefined;
  roleName: string = '';
  showOtherSpecialityField: boolean = false;  webinarAmount: number = 0;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  hostImageUrl: any = '';
  eventType: string = 'webinar';

  constructor(
    private sweetAlertService: SweetAlertService,
    private breadcrumbService: BreadcrumbService,
    private fb: FormBuilder,
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer,
    private webinarService: WebinarService,
    private oemService: OemService,
    private fileUploadService: FileUploadService,
    private masterDataService: MasterDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.roleName = this.localStorageService.getItem('roleName');
    switch (this.roleName) {
      case 'DISTRIBUTOR':
        this.oemId = this.localStorageService.getItem('distributorId');
        break;
      case 'OEM':
        this.oemId = this.localStorageService.getItem('oemId');
        break;
      default:
        this.oemId = this.localStorageService.getItem('userId');
        break;
    }
    const paths = this.activatedRoute.snapshot.url;
    if (paths.length > 1) {
      this.addWebinar = paths[1].path === 'add';
      this.updateWebinar = paths[1].path === 'edit';
      if (this.updateWebinar && paths.length > 2) {
        this.updateWebinarID = paths[2]?.path;
      }
    }
  }

  specialityData: any[] = [];

  addSpeakers(event: MatChipInputEvent) {
    const value = (event.value || '').trim();
    if (value) {
      this.speakersName.push(value);
      this.addWebinarForm?.get('speakersName')?.setValue(this.speakersName)
    }
    event.chipInput!.clear();
  }

  removeSpeaker(certificate: any) {
    const index = this.speakersName.indexOf(certificate);
    if (index >= 0) {
      this.speakersName.splice(index, 1);
      this.addWebinarForm?.get('speakersName')?.setValue(this.speakersName)
      this.announcer.announce(`Removed ${certificate}`);
    }
  }

  ngOnInit(): void {
    this.fetchAllSpecialities();
    this.timeZones();
    this.addWebinarForm = this.fb.group({
      webinarTitle: new FormControl('', [Validators.required]),
      image: new FormControl('', [Validators.required]),
      speakersName: new FormControl([], [Validators.required]),
      orgName: new FormControl('', [Validators.required]),
      orgEmail: new FormControl('', [Validators.required, Validators.email]),
      orgPhone: new FormControl('', [Validators.required]),
      speciality: new FormControl('', [Validators.required]),
      hostImage: new FormControl('', [Validators.required]),
      aboutWebinar: new FormControl('', [Validators.required]),
      webinarDate: new FormControl(''),
      webinarTime: new FormControl(''),
      timezone: new FormControl(''),
      estdH: new FormControl(''),
      estdM: new FormControl(''),
      estdS: new FormControl(''),
      webinarSource: new FormControl('', [Validators.required]),
      webinarUrl: new FormControl('', [Validators.required,Validators.pattern(/^https:\/\/.*/)]),
      webinarRecordUrl: new FormControl(''),
      sponsored: new FormControl(false),
      participantsLimit: new FormControl(),

      isPaid: new FormControl(false),
      amount: new FormControl(''),
      eventType: new FormControl('webinar'),
    });

    this.addWebinarForm.get('webinarDate')?.valueChanges.subscribe(date => {
      const timeControl = this.addWebinarForm.get('webinarTime');
      if (date) {
        timeControl?.setValidators([Validators.required]);
      } else {
        timeControl?.clearValidators();
      }
      timeControl?.updateValueAndValidity();
    });
    
    this.addWebinarForm.get('webinarTime')?.valueChanges.subscribe(time => {
      const timezoneControl = this.addWebinarForm.get('timezone');
      if (time) {
        timezoneControl?.setValidators([Validators.required]);
      } else {
        timezoneControl?.clearValidators();
      }
      timezoneControl?.updateValueAndValidity();
    });

     this.addWebinarForm.get('isPaid')?.valueChanges.subscribe(isPaid => {
        const amountControl = this.addWebinarForm.get('amount');
        if (isPaid) {
            amountControl?.setValidators([Validators.required]);
        } else {
            amountControl?.clearValidators();
        }
        amountControl?.updateValueAndValidity();
    });
    
    if (this.updateWebinar) {
      this.updateWebinarMethod(this.updateWebinarID);
    }
    this.addWebinarForm.valueChanges.subscribe(() => {
      this.iswebinarActive = !this.isWebinarActive();
    });
    if (!this.updateWebinar) {
      this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Add Webinar']);
    }
    this.filteredSources = this.addWebinarForm.get('webinarSource')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOptions(value || '', this.sources))
    );
    this.filteredHours = this.addWebinarForm.get('estdH')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOptions(value, this.estdHH))
    );
    this.filteredMinutes = this.addWebinarForm.get('estdM')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOptions(value, this.estdMM))
    );

    this.filteredSeconds = this.addWebinarForm.get('estdS')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOptions(value, this.estdSS))
    );
  }
  sanitizeContent() {
    const rawContent = this.addWebinarForm.get('aboutWebinar')?.value;
    const sanitizedContent = this.stripHtmlTags(rawContent);
    this.addWebinarForm.patchValue({ aboutWebinar: sanitizedContent });
  }

  stripHtmlTags(content: string): string {
    return content ? content.replace(/<font[^>]*>/g, '').replace(/<\/font>/g, '') : '';
  }

  fetchAllSpecialities(pageNumber: number = 0, pageSize: number = 100): void {
    this.webinarService.getSpeciality(pageNumber, pageSize).subscribe((data: any) => {
      if (data && data.data) {
        const specialties = data.data.map((spec: any) => spec.specialty);
        this.specialityData.push(...specialties);
        this.specialityData.sort();
        if (data.data.length === pageSize) {
          this.fetchAllSpecialities(pageNumber + 1, pageSize);
        } else {
          this.specialities = [...this.specialityData];
          this.setupSpecialityAutocomplete();
        }
      }
    });
  }

  private setupSpecialityAutocomplete() {
    this.filteredSpeciality = this.addWebinarForm.get('speciality')!.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterOptions(value, this.specialities))
    );

    // this.addWebinarForm.get('speciality')!.valueChanges.subscribe((value: string) => {
    //   const otherSpecialityControl = this.addWebinarForm.get('otherSpeciality');
    
    //   if (value && value.toLowerCase().startsWith('other')) {
    //     otherSpecialityControl?.setValidators([Validators.required]);
    //   } else {
    //     otherSpecialityControl?.clearValidators();
    //     otherSpecialityControl?.setValue(null); // optional: clear the field if not needed
    //   }
    
    //   otherSpecialityControl?.updateValueAndValidity();
    // });
  }
  // onMasterDataChange(event: any,type: string) {
  //   this.addWebinarForm.get('otherMasterData')?.setValue({ type: type, name: event.target.value }); 
  // }
  private _filterOptions(value: string, options: string[]): string[] {
    const filterValue = value?.toLowerCase() ?? '';
    return options.filter(option => option.toLowerCase().includes(filterValue));
  }
  onSpecialitySelected(event: MatAutocompleteSelectedEvent) {
    if(event.option.value=='other'){
      this.showOtherSpecialityField=true;
    }else{
      this.showOtherSpecialityField=false;
    }
    this.addWebinarForm.get('speciality')?.setValue(event.option.value);
  }
  timeZones() {
    this.masterDataService.getTimezones().subscribe((res: any) => {
      res.data?.map((d: any) => {
        this.timezones.push(d.viewTime)
      })
    })
  }
  filterTimezones() {
    this.filteredTimezones = this.timezones.filter(tz =>
      tz.toLowerCase().includes(this.searchTimezone.toLowerCase())
    );
  }

  formatTime(time: string): string {
    return `2022-01-11T${time}:00.000Z`;
  }
  formatDate(date: any): string {
    return `${date}T00:00.000Z`
  }

  estdHH = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23'
  ];
  filteredHours!: Observable<string[]>;
  filteredMinutes!: Observable<string[]>;
  filteredSeconds!: Observable<string[]>;
  estdMM = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
    '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
    '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
  ];
  estdSS = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']
  sources = ['Google Meet', 'Zoom Meet', 'Skype', 'Other'];
  filteredSources!: Observable<string[]>;

  private uploadFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destinationKey', '/webinar/');

    return this.fileUploadService.uploadFile(formData).pipe(
      map((response: any) => {
        if (response && response.data) {
          return response.data;
        } else {
          throw new Error('Invalid response format from server.');
        }
      })
    );
  }
  isImageFile(filePath: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.img', '.svg'];
    return imageExtensions.some(ext => filePath.toLowerCase().endsWith(ext));
  }

  private getFileNameFromUrl(url: string): string {
    return url.split('/').pop() || '';
  }

  isAllowedFileType(fileName: string): boolean {
    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.img', '.svg', '.html', '.htm'];
    const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return allowedExtensions.includes(ext);
  }


  fileSizeError: boolean = false;

  selectFile(event: any, type: string, isDrop: boolean): void {
    event.preventDefault();
     const file: File = isDrop ? event.dataTransfer.files[0] : event.target.files[0];
    this.fileSizeError = false;
    if (file) {
        if (!this.isAllowedFileType(file.name)) {
          Swal.fire({
                icon: 'error',
                title: 'Invalid file type',
                text: 'Please select only image files'
            });
            this.resetFileInput(isDrop ? null : event.target);
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
          Swal.fire({ icon: 'error', title: 'File size is too large', text: 'Please select a file smaller than 10MB' });
            this.resetFileInput(isDrop ? null : event.target);
            return;
        }

        this.currentFile = file;
        this.fileName = this.getFileNameFromUrl(file.name);
        this.selectedFileName = this.fileName;
        this.uploadFile(file).subscribe((response) => {
       if (type === 'host') {
                this.hostImageUrl = response;
                this.addWebinarForm.get('hostImage')?.setValue(response);
            } else if (type === 'featured') {
                this.addWebinarForm.get('image')?.setValue(response);
                this.imageUrl = response;
            }
            this.resetFileInput(isDrop ? null : event.target);
            this.currentFile = undefined;
            this.selectedFileName = null;
        });
      }
  }
  resetFileInput(inputElement: HTMLInputElement | null): void {
    if (inputElement) {
      inputElement.value = '';
    }
  }

  onDragOver(event: any) {
    event.preventDefault();
  }
  clearSelectedFile(type: string): void {
    if (type === 'featured') {
      this.currentFile = undefined;
      this.selectedFileName = null;
      this.fileName = '';
      this.imageUrl = '';
      this.addWebinarForm.get('image')?.setValue('');
      if (!this.addWebinarForm.get('image')?.value) {
        this.addWebinarForm.get('image')?.setErrors({ required: true });
      }
    }
    else if (type === 'host') {
      this.hostImageUrl = '';
      this.currentFile = undefined;
      this.selectedFileName = null;
      this.fileName = '';
      this.addWebinarForm.get('hostImage')?.setValue('');
      if (!this.addWebinarForm.get('hostImage')?.value) {
        this.addWebinarForm.get('hostImage')?.setErrors({ required: true });
      }
    }
  }

  back(): void {
    if (this.returnPath) {
      this.router.navigate([this.returnPath]);
    } else {
      const urlSegments = this.router.url.split('/').filter(segment => segment);
      const currentUrl = this.router.url;
      if (currentUrl.includes('/edit/') || currentUrl.includes('/add')) {
        const baseUrlSegments = [];
        for (let i = 0; i < urlSegments.length; i++) {
          baseUrlSegments.push(urlSegments[i]);
          if (
            (i < urlSegments.length - 1 &&
              (urlSegments[i + 1] === 'edit' || urlSegments[i + 1] === 'add'))
          ) {
            break;
          }
        }

        const baseUrl = '/' + baseUrlSegments.join('/');
        this.router.navigate([baseUrl]);
      } 
    }

    this.closeToBack.emit(true);
    this.backEvent.emit({ actionType: '' });
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Webinars']);
  }
  formatDateToISO(date: Date): string {
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  swalError() {
    Swal.fire(
      'Please fill all fields',
      '',
      'warning'
    );
  }

  image: string = '/src/assets/images/pdf-icon-image.svg';

  saveForm(): void {
    if (!this.isFormValid()) {
      this.addWebinarForm?.get('speakersName')?.markAsTouched();
      this.addWebinarForm?.get('image')?.markAsTouched();
      this.addWebinarForm?.get('hostImage')?.markAsTouched();
      this.addWebinarForm?.get('aboutWebinar')?.markAsTouched();
      this.addWebinarForm?.get('webinarTime')?.markAsTouched();
    }
    if (!this.addWebinarForm.valid) {
      this.swalError();
    } else if (this.addWebinarForm.valid) {
      const amountValue = this.addWebinarForm.get('amount')?.value;
      if(amountValue === null || amountValue === undefined || amountValue === '') {
        this.addWebinarForm.get('amount')?.setValue(null);
        this.addWebinarForm.get('isPaid')?.setValue(false);
      } else if(amountValue) {
        this.addWebinarForm.get('isPaid')?.setValue(true);
      }
      const formData = { ...this.addWebinarForm.value };
      const formattedDate = this.formatDateToISO(formData.webinarDate);
      const formattedTime = `${formData.webinarTime.hour}:${formData.webinarTime.minute}:${formData.webinarTime.second}`;
      let dur = '00:00:00';
      if (formData.estdH && formData.estdS && formData.estdS) {
        dur = `${formData.estdH}:${formData.estdM}:${formData.estdS}`;
      }
      this.formatDate(formData.webinarDate)

      const submissionData = {
        webinarTitle: formData.webinarTitle,
        image: this.imageUrl || null,
        speakersName: this.speakersName,
        orgName: formData.orgName,
        orgEmail: formData.orgEmail,
        orgPhone: String(formData.orgPhone),
        hostImage: this.hostImageUrl || null,
        aboutWebinar: formData.aboutWebinar,
        webinarDate: formattedDate,
        webinarTime: formData.webinarTime,
        timezone: formData.timezone,
        applicationCloseDate: formData.applicationCloseDate,
        webinarSource: formData.webinarSource,
        webinarUrl: formData.webinarUrl,
        webinarRecordUrl: formData.webinarRecordUrl,
        sponsored: formData.sponsored,
        speciality: formData.speciality,
        duration: dur,
        createdBy: this.oemId,
        participantsLimit: parseInt(formData.participantsLimit, 10),
        type: this.eventType,
        ...(this.eventType === 'cme' ? {
          paid: formData.isPaid,
          amount: formData.amount
        } : {})
      };

      if(!this.updateWebinar){
        this.webinarService.createWebinar(submissionData).subscribe((res: any)=>{
          Swal.fire({
            icon: 'success',
            title: this.eventType === 'webinar' ? 'Webinar Added Successfully' : 'CME Added Successfully',
          }).then((res) => {
            if (res.isConfirmed) {
              this.back();
            }
          })
        },
        error => {
          if(error) {
            Swal.fire(
              'Please fill all fields',
              '',
              'warning'
            );
          }
        }
      )
      }
      else {
        const formData = { ...this.addWebinarForm.value };
        this.webinarService.updateWebinar(this.updateWebinarID, submissionData).subscribe((res: any) => {
           this.sweetAlertService.showSuccess('', this.eventType === 'webinar' ? 'Webinar Updated Successfully.' : 'CME Updated Successfully.').then(result => {
            this.back();
          });

        },
          error => {
            if (error) {
              this.swalError();
            }
          }
        )
      };
    }
  }
  isFormValid(): boolean {

    const nameValid = this.addWebinarForm?.get('speakersName')?.valid ?? false;
    const imageValid = this.addWebinarForm?.get('image')?.valid ?? false;
    const hostImageValid = this.addWebinarForm?.get('hostImage')?.valid ?? false;
    const webinarValid = this.addWebinarForm?.get('aboutWebinar')?.valid ?? false;
    const timeValid = this.addWebinarForm?.get('webinarTime')?.valid ?? false;

    return webinarValid && timeValid && nameValid && imageValid && hostImageValid;
  }

  reformatTime(t: any): string {
    if (!t) {
      return '';
    }
    let hours = t[0];
    const minutes = t[1];
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    return `${formattedHours}:${formattedMinutes}`;
  }

  reformatDuration(duration: any) {
    if (duration.length === 2) {
      duration.push(0);
    }
    let h = String(duration[0])
    let m = String(duration[1])
    let s = String(duration[2])
    if (h.length === 1) {
      h = '0' + h
    }
    if (m.length === 1) {
      m = '0' + m
    }
    if (s.length === 1) {
      s = '0' + s
    }
    return [h, m, s]
  }

  getFileName(url: string) {
    const parts = url.split('/');
    return parts[parts.length - 1];
  }

  updateWebinarMethod(id: string) {
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Edit Webinar']);
    this.webinarService.getWebinarById(id).subscribe((res: any) => {
      const d = res?.data?.webinar;
      if(d.paid){
        this.isPaid = true;
        this.addWebinarForm.get('isPaid')?.setValue(true);
        this.webinarAmount = d.amount;
      }
      this.speakersName = d.speakersName;
      const dur = this.reformatDuration(d.duration);
      const timee = this.reformatTime(d.webinarTime)
      let dur_toggle = false;
      (dur) ? (dur_toggle = true) : (dur_toggle = false)
      const formattedDate = d.webinarDate ? `${d.webinarDate[1]}/${d.webinarDate[2]}/${d.webinarDate[0]}` : 'N/A';

      this.addWebinarForm.patchValue({
        webinarTitle: d.webinarTitle,
        orgName: d.orgName,
        orgEmail: d.orgEmail,
        orgPhone: d.orgPhone,
        image: d.image,
        hostImage: d.hostImage,
        aboutWebinar: d.aboutWebinar,
        webinarDate: (d.webinarDate) ? new Date(formattedDate) : null,
        timezone: d.timezone,
        webinarSource: d.webinarSource,
        webinarUrl: d.webinarUrl,
        webinarRecordUrl: d.webinarRecordUrl,
        sponsored: d.sponsored,
        estdH: dur.length === 3 ? dur[0] : null,
        estdM: dur.length === 3 ? dur[1] : null,
        estdS: dur.length === 3 ? dur[2] : null,
        speciality: d.speciality,
        speakersName: d.speakersName,
        webinarTime: timee,

        participantsLimit: parseInt(d.participantsLimit, 10),
        amount: d.amount ? d.amount : null,
        isPaid: d.paid ? d.paid  : false,
        eventType: d.paid ? 'cme': 'webinar',
        type: d.type,

      })
      this.eventType = d.paid ? 'cme': 'webinar';
      this.imageUrl = d.image;
      this.hostImageUrl = d.hostImage
      this.speakersName = d.speakersName

    })
  }
  capitalizeFirstLetter() {
    let titleControl = this.addWebinarForm.get('webinarTitle');

    if (titleControl && titleControl.value) {
      let value = titleControl.value;
      let newValue = value.replace(/(^\w{1})|(\s+\w{1})/g, (letter: string) => letter.toUpperCase());
      titleControl.setValue(newValue, { emitEvent: false });
    }
  }

  isWebinarActive(): boolean {
    const formData = this.addWebinarForm.value;
    
    if (!formData.webinarDate || !formData.webinarTime) {
      return false;
    }
    let webinarDate: Date;
    if (formData.webinarDate instanceof Date) {
      webinarDate = new Date(formData.webinarDate);
    } else {
      webinarDate = new Date(formData.webinarDate);
    }
    let webinarTime = '';
    if (typeof formData.webinarTime === 'string') {
      webinarTime = formData.webinarTime;
    } else if (formData.webinarTime && formData.webinarTime.hour !== undefined) {
      const hour = String(formData.webinarTime.hour).padStart(2, '0');
      const minute = String(formData.webinarTime.minute).padStart(2, '0');
      const second = String(formData.webinarTime.second || 0).padStart(2, '0');
      webinarTime = `${hour}:${minute}:${second}`;
    }
    const year = webinarDate.getFullYear();
    const month = webinarDate.getMonth();
    const day = webinarDate.getDate();
    const [hours, minutes, seconds] = webinarTime.split(':').map(Number);
    const webinarDateTime = new Date(year, month, day, hours || 0, minutes || 0, seconds || 0);
    const now = new Date();
    return webinarDateTime > now;
  }

 onSelectEventType(event: any) {
    if(event.type === "change") {
      this.eventType = event.target.value;
    }
  }

  isPaid: boolean = false;
  isCmePayable(event: any) {
    const input = event.target as HTMLInputElement;
    this.isPaid = input.checked;
  }

  cmeAmountChange(event: any) {
    const input = event.target as HTMLInputElement;
    const amount = input.value;
    if(amount === '' || amount === null || amount === undefined) {
      this.addWebinarForm.get('amount')?.setValue(null);
    } else if(amount) {
    
      this.addWebinarForm.get('amount')?.setValue(amount);
    }
  }
}